import { integerInput, selectInput } from '../../inputs/controls'
import { coreSettingsErrors } from './coreSettingsErrors'
import { ProductStatusOnStart } from '../../../types/coreSettings'

export const getCoreSettingsControlDescriptors = (state: any) => [
    integerInput({
        name: 'restart_attempts',
        isColumn: true,
        label: 'Restart attempts',
        errMsg: coreSettingsErrors.restartAttempts(state),
        className: 'w-100',
        tooltipText: 'Number of application restart attempts',
        placeholder: 'Default value',
    }),
    integerInput({
        name: 'restart_delay_sec',
        isColumn: true,
        label: 'Restart delay sec',
        errMsg: coreSettingsErrors.restartDelaySec(state),
        className: 'w-100',
        tooltipText: 'Delay in seconds between each restart attempt',
        placeholder: 'Default value',
    }),
    selectInput({
        name: 'product_status_on_start',
        options: Object.keys(ProductStatusOnStart),
        selected:
            state?.['product_status_on_start'] ||
            Object.keys(ProductStatusOnStart)[0],
        isColumn: true,
        label: 'Product status on start',
    }),
]